import type { FaireProductEntity } from "../../entity_types/product";

export const p_jnzc35q5hs: FaireProductEntity = {
  token: "p_jnzc35q5hs",
  type: "product",
  name: "2 Lbs Natural Blue Rose Quartz Tumble Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8dbfe863d2257212cfe91e8752d58eaa62a2512e136047a5e62b3e9e61cb3770.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0f67a99e15e0093b9188931dfcdc87256f43c70ebc8875016c1eaa9b7683c55.jpeg",
    "https://cdn.faire.com/fastly/987d9540060db0bbc84ff1159b1a1706b0f9d81499c5739c738c6edc3c45fc9d.jpeg",
    "https://cdn.faire.com/fastly/3fdf38034bbaeb1c8ce9ffbabb660144a84cf021714b9abfe35184180d74f085.jpeg",
    "https://cdn.faire.com/fastly/f193ffbc1d976c8ae4018e03a1ef5e7f4ae5f6ded281091bc8a44fcbab0a7dbe.jpeg",
    "https://cdn.faire.com/fastly/ee69ce416d3175fb56176ca0f585af9fa7e7ea32f6733e6d39816355121be518.jpeg",
    "https://cdn.faire.com/fastly/682c3bd6d256a765e0dfbc708427c1ebf55c98c1af433a436f60c548c67fca43.jpeg",
    "https://cdn.faire.com/fastly/5ad7c6a2f6fe6a3dce35c6b84d29cbd528f2e5c144cae88fe8bf3002889b294b.jpeg",
  ],
  priceDollars: 48.5,
  description:
    "Wholesale lot 2 lbs Natural Blue Rose Quartz tumble crystal. Amazonite is found in Madagascar. Condition is New. Condition is New. \n\nFree local pickup in Brooklyn, New York.  \n\nStones, crystal, crystal bulk, spiritual, meditation, metaphysical wholesale. \n",
  tags: [],
  msrpDollars: 97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:55.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
